import { CUSTOMER_ADMIN, LCAADMIN, ORGANIZATION_ACCESS_ROLES, USER, USER_ACCESS_ROLES } from "@app/portal/admin/admin.constants";
import { Organization, SearchOption, UserRole } from "..";
import { IUser } from "./i-user";
import { AnalyticReport } from "../admin/analytic-report";

export class User implements IUser {
  employerName: string;
  isActive?: boolean;
  firstName: string;
  lastName: string;
  userId?: number;
  organizations: Organization[];
  userLoginName: string;
  role: UserRole;
  resendActivation: boolean;
  hasRestrictedAnalytes: boolean;
  eulaId: number;
  userEulaAcceptedTime: Date;
  eulaAcceptedTime: string;
  restrictedAnalytes?: string[];
  allowFTPSearch?: boolean;
  showResultStatusLink?: boolean;
  sendSearchResultEmail?: boolean;
  searchOption?: SearchOption;
  analyticReports?: AnalyticReport[];
  allowSearch?: boolean;

  constructor(
    employerName: string,
    firstName: string,
    lastName: string,
    organizations: Organization[],
    userLoginName: string,
    role: UserRole,
    resendActivation: boolean,
    hasRestrictedAnalytes: boolean,
    isActive?: boolean,
    userId?: number,
    eulaAcceptedTime?: string,
    restrictedAnalytes?: string[],
    allowFTPSearch?: boolean,
    showResultStatusLink?: boolean,
    sendSearchResultEmail?: boolean,
    searchOption?: SearchOption,
    analyticReports?: AnalyticReport[],
    allowSearch?: boolean,
  ) {
    this.employerName = employerName;
    this.firstName = firstName;
    this.lastName = lastName;
    this.organizations = organizations || [];
    this.userLoginName = userLoginName;
    this.role = role;
    this.resendActivation = resendActivation;
    this.hasRestrictedAnalytes = hasRestrictedAnalytes;
    this.isActive = isActive;
    this.userId = userId;
    this.eulaAcceptedTime = eulaAcceptedTime;
    this.userEulaAcceptedTime = new Date(eulaAcceptedTime);
    this.restrictedAnalytes = restrictedAnalytes || [];
    this.allowFTPSearch = allowFTPSearch;
    this.showResultStatusLink = showResultStatusLink;
    this.sendSearchResultEmail = sendSearchResultEmail;
    this.searchOption = searchOption;
    this.analyticReports = analyticReports || [];
    this.allowSearch = allowSearch;
  }

  static userFactory(u: IUser): User {
    if (u) {
      return new User(
        u.employerName,
        u.firstName,
        u.lastName,
        u.organizations,
        u.userLoginName,
        u.role,
        u.resendActivation,
        u.hasRestrictedAnalytes,
        u.isActive,
        u.userId,
        u.eulaAcceptedTime,
        u.restrictedAnalytes,
        u.allowFTPSearch,
        u.showResultStatusLink,
        u.sendSearchResultEmail,
        u.searchOption,
        u.analyticReports,
        u.allowSearch,
      );
    }

    return undefined;
  }

  get isLCAAdmin(): boolean {
    return this.role && this.role.roleName === LCAADMIN;
  }

  get isFTPUser(): boolean {
    return this.role && this.role.roleName === LCAADMIN && this.allowFTPSearch;
  }

  get isGapsInCareUser(): boolean {
    return this.role && this.analyticReports && this.analyticReports.find( v => v.type === 'GIC') !== undefined ;
  }
 
  get isInsightAnalyticUser(): boolean {
    return this.role && this.analyticReports && this.analyticReports.find( v => v.type === 'IA') !== undefined;
  }

  get isCustomerAdmin(): boolean {
    return this.role && this.role.roleName === CUSTOMER_ADMIN;
  }

  get isUser(): boolean {
    return this.role && this.role.roleName === USER;
  }

  get canAccessOrganizations(): boolean {
    return ORGANIZATION_ACCESS_ROLES.indexOf(this.role?.roleName) > -1;
  }

  get canAccessUsers(): boolean {
    return USER_ACCESS_ROLES.indexOf(this.role?.roleName) > -1;
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  get organizationNames(): string {
    const names: string[] = [];
    this.organizations.forEach(org => names.push(org.orgName));
    names.sort();
    return names.join(', ');
  }

  get restrictedAnalytesSortOrder(): number {
    if (this.restrictedAnalytes && this.restrictedAnalytes.length > 0) {
      return 0;
    } else {
      return 1;
    }
  }

  get roleDesc(): string {
    if (this.role) {
      return this.role.roleDesc;
    } else {
      return '';
    }
  }

}
